import useIncomingPostMessages from '@rio-cloud/rio-uikit/hooks/useIncomingPostMessages';
import usePostMessageSender from '@rio-cloud/rio-uikit/hooks/usePostMessageSender';
import { useEffect } from 'react';

import { mapStopsToRoute } from '#features/livemonitor/model/TourStopMapper.ts';
import { useAppDispatch, useAppSelector } from '#store/store';
import {
    assetIdSelected,
    mapMarkerSelected,
    selectIsWidgetVisible,
    selectSelectedTour,
    visibleWidgetsSet,
    widgetIdSet,
} from '#store/widgetSlice';

export const MessageHandler = () => {
    const { sendMessageToParent } = usePostMessageSender();
    const dispatch = useAppDispatch();
    const tour = useAppSelector(selectSelectedTour);
    const isWidgetVisible = useAppSelector(selectIsWidgetVisible);

    const stopsLength = tour?.stops.length ?? 0;

    useIncomingPostMessages({
        handlers: {
            // biome-ignore lint/correctness/noNestedComponentDefinitions: this is not a component
            EVENT_SELECT_ASSET: (payload: { id: string }) => {
                dispatch(assetIdSelected(payload.id));
            },
            // biome-ignore lint/correctness/noNestedComponentDefinitions: this is not a component
            EVENT_MAP_MARKER_SELECTED: (payload: { id: string }) => {
                dispatch(mapMarkerSelected(payload.id));
            },
            // biome-ignore lint/correctness/noNestedComponentDefinitions: this is not a component
            EVENT_SET_WIDGET_ID: (payload: string | undefined) => {
                console.log('EVENT_SET_WIDGET_ID', payload);
                dispatch(widgetIdSet(payload));
            },
            // biome-ignore lint/correctness/noNestedComponentDefinitions: this is not a component
            EVENT_SET_VISIBLE_WIDGETS: (payload: string[]) => {
                console.log('EVENT_SET_VISIBLE_WIDGETS', payload);
                dispatch(visibleWidgetsSet(payload));
            },
        },
    });

    useEffect(() => {
        sendMessageToParent({
            type: 'EVENT_WIDGET_LOADED',
        });
    }, []);

    useEffect(() => {
        if (!isWidgetVisible || !tour || stopsLength === 0) {
            sendMessageToParent({
                type: 'EVENT_RENDER_ROUTE',
                payload: {
                    segments: [],
                    markers: [],
                },
            });
            return;
        }

        const { markers, segments, bbox } = mapStopsToRoute(tour.stops);

        sendMessageToParent({
            type: 'EVENT_RENDER_ROUTE',
            payload: {
                segments,
                markers,
            },
        });

        if (bbox) {
            sendMessageToParent({
                type: 'EVENT_SET_BOUNDING_BOX',
                payload: {
                    bbox,
                },
            });
        }
    }, [isWidgetVisible, sendMessageToParent, stopsLength, tour]);

    return null;
};
